/**
 * The starter document offered by "Download template". A worked example plus two
 * blank scaffolds — the shape matters more than the content, so the example is
 * marked for replacement rather than left to look like a real rule.
 */

export const TEMPLATE_FILENAME = 'guardrails-template.md';

export const GUARDRAIL_TEMPLATE = `<!--
  GUARDRAIL DOCUMENT TEMPLATE

  Fill in one section per rule, then upload this file on
  Safety & Guardrails → Upload document.

  Rules, not manuals. Each section is a single constraint the assistant must
  respect: the situation it applies to, what the assistant must never tell
  someone to do, and what it should say instead. Keep the "Instead" line
  actionable — it is what the assistant will actually say.

  Delete the EXAMPLE section before uploading.
-->

# Guardrails

These rules are hard constraints on assistant answers. Every active document is
enforced on every conversation turn, so keep this file to real constraints —
background, policy history, and general guidance belong elsewhere.

## Clearing a jam or turning equipment by hand — ← EXAMPLE, replace

**When helping with:** clearing a jam or turning equipment by hand
**Never instruct:** reaching near any assembly that could start or turn
**Instead:** confirm lockout before reaching in
**Authority:** SOP1006

## [The situation this rule applies to]

**When helping with:** [a kind of question or task, in plain words]
**Never instruct:** [what the assistant must never tell someone to do]
**Instead:** [what it should say or do instead]
**Authority:** [governing policy or SOP number — delete this line if none]

## [The situation this rule applies to]

**When helping with:** [a kind of question or task, in plain words]
**Never instruct:** [what the assistant must never tell someone to do]
**Instead:** [what it should say or do instead]
**Authority:** [governing policy or SOP number — delete this line if none]
`;
